export const LOGGED_OUT = 'LOGGED_OUT';
export const SESSION_EXPIRED = 'SESSION_EXPIRED';
export const HANDOFF_FAILED = 'HANDOFF_FAILED';
